import {Inject, Injectable, Optional, SkipSelf} from "@angular/core";

import {HttpClient} from "@angular/common/http";
import {Observable} from 'rxjs';
import {shareReplay} from 'rxjs/operators';

import {TypeMaintenanceTLR} from '../entities/type-maintenance-tlr.entity';

import {BasicDataSubService} from '../../../../shared/basic-data-management/basic-data-subservice.class';
import {TreeNode} from '../../../../shared/basic-data-management/tree-node.entity';
import {HttpService} from '../../../../shared/ajs-bridges/http.service';

@Injectable({ providedIn: 'root' })
export class TypeMaintenanceService {
	private path: string;

	private typeMaintenanceSubService!: BasicDataSubService<TypeMaintenanceTLR>;
	private typeMaintenanceRootsSubService!: BasicDataSubService<TypeMaintenanceTLR>;
	private typeMaintenanceRecurrentsSubService!: BasicDataSubService<TypeMaintenanceTLR>;

	constructor( //
		@Inject(HttpClient) private httpClient: HttpClient, //
		@Inject(HttpService) private httpService: HttpService, //
		@Optional() @SkipSelf() previousInstance?: TypeMaintenanceService //
	) {
		if (previousInstance) {
			throw new Error(
				'This service is already loaded. Import it in the AppModule only');
		}
		this.path = (window as any).baseApiPath;

		this.typeMaintenanceSubService = new BasicDataSubService<TypeMaintenanceTLR>(httpClient, this.path + 'typeMaintenance?format=TLR');
		this.typeMaintenanceRootsSubService = new BasicDataSubService<TypeMaintenanceTLR>(httpClient, this.path + 'typeMaintenance?format=TLR&rootsOnly=true&validOnly=true');
		this.typeMaintenanceRecurrentsSubService = new BasicDataSubService<TypeMaintenanceTLR>(httpClient, this.path + 'typeMaintenance?format=TLR&recurrentOnly=true');
	}

	public getTypeMaintenances(): Observable<TypeMaintenanceTLR[]> {
		return this.typeMaintenanceSubService.getList();
	}

	public getTypeMaintenancesMap(): Observable<Map<number, TypeMaintenanceTLR>> {
		return this.typeMaintenanceSubService.getMapById();
	}

	public getTypeMaintenancesRecurrents(): Observable<TypeMaintenanceTLR[]> {
		return this.typeMaintenanceRecurrentsSubService.getList();
	}

	public getTypeMaintenancesRecurrentsMap(): Observable<Map<number, TypeMaintenanceTLR>> {
		return this.typeMaintenanceRecurrentsSubService.getMapById();
	}

	public getTypeMaintenancesRacinesValides(): Observable<TypeMaintenanceTLR[]> {
		return this.typeMaintenanceRootsSubService.getList();
	}
	
	public getTypeMaintenancesByParcAndClasse(parcId: number, classeOuvrageId: number): Observable<TypeMaintenanceTLR[]> {
		let url = this.path + 'typeMaintenance?format=TLR&parc=' + parcId + '&classe=' + classeOuvrageId;
		let result = this.httpClient //
			.get<TypeMaintenanceTLR[]>(url) //
		;

		return result;
	}

	public getReccurentTypeMaintenancesByParcAndClasse(parcId: number, classeOuvrageId: number): Observable<TypeMaintenanceTLR[]> {
		let url = this.path + 'typeMaintenance?format=TLR&parc=' + parcId + '&classe=' + classeOuvrageId + '&recurrentsOnly=true';
		let result = this.httpClient //
			.get<TypeMaintenanceTLR[]>(url) //
		;

		return result;
	}
	
	public getLibellesTypeMaintenancesByParcAndClasse(parcIds: number[], classeOuvrageIds: number[]): Observable<string[]> {
		let url = this.path + 'typeMaintenance/libelles?parc=' + parcIds.join(',') + '&classeOuvrageIds=' + classeOuvrageIds.join(',');
		let result = this.httpClient.get<string[]>(url);
		return result;
	}

	private treeCache!: Observable<TreeNode<TypeMaintenanceTLR>[]>;
	public getTypeMaintenanceFullTree(useCache: boolean): Observable<TreeNode<TypeMaintenanceTLR>[]> {
		if (!useCache || !this.treeCache) {
			let url = this.path + 'typeMaintenance?format=tree';
			this.treeCache = this.httpClient //
				.get<TreeNode<TypeMaintenanceTLR>[]>(url) //
				.pipe(
					shareReplay(1)
				) //
				;
		}

		return this.treeCache;
	}

	public getSuggestions(criteria: string, parcId: number, classeOuvrageIds: number[], quantity: number) : Promise<any> {
		console.log("Appel au service de suggestion d\'un type de maitenance pour le critère : " + criteria);
		let url = this.path + 'typeMaintenance/suggestions?criteria=' + encodeURI(criteria) + '&parc=' + parcId + '&classeOuvrageIds=' + classeOuvrageIds.join(',')
			+ '&limit=' + quantity;
		console.log(url);
		return this.httpService.get(url);
	}

	public getTypeMaintenanceFullTreeWithoutObsolete(useCache: boolean): Observable<TreeNode<TypeMaintenanceTLR>[]> {
		if (!useCache || !this.treeCache) {
			let url = this.path + 'typeMaintenance?format=tree&validOnly=true';
			this.treeCache = this.httpClient //
				.get<TreeNode<TypeMaintenanceTLR>[]>(url) //
				.pipe(
					shareReplay(1)
				) //
			;
		}

		return this.treeCache;
	}
	
	public getRecurrenceLabel(type: TypeMaintenanceTLR): string {
		if (type.recurrent) {
			if (type.periodicite === 0) {
				return "Non définie";
			} else {
				return "" + type.periodicite + "m";
			}
		} else {
			return "Non récurrent";
		}
	}

	public getLabelWithRecurrence(type: TypeMaintenanceTLR): string {
		let recurrenceLibelle = this.getRecurrenceLabel(type);
		return type.libelle + " (" + recurrenceLibelle + ")";
	}
}